// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col___PXxM","checkboxCol":"Table_checkboxCol__1TWeW","emailCol":"Table_emailCol__VXmjO","actionCol":"Table_actionCol__32UGh"};